// Máscaras de INPUT numérico pt-BR do PCP (ordem do owner 2026-08-02: "coloque
// também em tudo do PCP"). Três formatos: monetário `R$ x.xxx.xxx,xx`,
// percentual/decimal com vírgula, e inteiro (só dígitos).
//
// Sem dependência nova (mesma regra das demais máscaras do repo — `maskCPF`,
// `maskCEP`, `maskPhoneBR` em lib/representatives.js): a formatação usa
// `toLocaleString("pt-BR")`, o MESMO motor do `formatBRL` (lib/api.js), para
// que o que o usuário DIGITA e o que a tela EXIBE sejam byte-idênticos.
//
// ── Contrato de estado ──────────────────────────────────────────────────────
// O estado do form guarda a string MASCARADA ("R$ 1.234.567,89", "2,5") e
// `parseDecimalBR` a desfaz na fronteira que monta o payload. Por isso NENHUM
// consumidor de campo mascarado pode usar `parseFloat` direto: `parseFloat(
// "1.234.567,89")` é `1.234` — corrupção SILENCIOSA de money-path. Fronteiras
// convertidas junto com esta lib: `mapReceivablePayload`/`RECEIVABLE_REQUIRED_
// FIELDS` (lib/operations.js), `buildStockFees` (lib/stockFees.js), o
// `taxaNum`/`totalReceivables` do wizard e o payload de item do Stock.
//
// ── Doutrina (fix rounds 2026-08-02/03, escada CC + OC decorrelado) ─────────
// 1. DECIMAL NATURAL, nunca fluxo-de-centavos. `10000` digitado é DEZ MIL, não
//    dez mil centavos. Fluxo-de-centavos torna todo paste um ×100 em potencial
//    e prende o campo em `R$ 0,00`.
//
//    ⚠️ REVERTIDO PARA OS CAMPOS DE DINHEIRO DO PCP — decisão do OWNER de
//    2026-08-21 (FS-160). O racional acima fica REGISTRADO, não apagado:
//    continua sendo a descrição correta do risco, e foi ele que a sessão levou
//    ao owner. O owner leu o efeito colateral ("colar `10000` de planilha vira
//    R$ 100,00") e o ACEITOU, em favor da ergonomia de caixa registradora:
//    "se colar ou escrever 954257 deve considerar R$ 9.542,57".
//    O que mudou, e o que NÃO mudou:
//    - `maskMoneyCentsBR` (nova) implementa o regime CAIXA REGISTRADORA e é a
//      máscara dos 4 campos de dinheiro do PCP (NewOperation, Stock).
//    - `maskMoneyBR` NÃO mudou uma linha: segue decimal natural e segue viva —
//      é ela que lê a CARGA PROGRAMÁTICA (ver §Carga) e é o motor do
//      `finalizeMoneyBR`. `maskDecimalBR`/`maskPctBR`/`parseDecimalBR` também
//      seguem 100% no regime natural (taxa NÃO é caixa registradora).
//    - o antídoto que este arquivo propunha ("digitação = centavos, paste =
//      decimal natural") NÃO entrou: o owner pediu digitação E paste com a
//      MESMA regra. Divergir faria a máscara mentir conforme o dígito chegou —
//      e `9.542,57` colado voltaria diferente de `954257` digitado.
//
//    ── REGRA HÍBRIDA DO PASTE (owner 2026-08-21, UX-1) ─────────────────────
//    Refinamento da P4 depois que o /myuxreview mediu o dano: um paste que
//    DECLARA a vírgula não pode ser lido como dígito solto (`1.234,5` virando
//    R$ 123,45 é um ÷10 na cara de quem escreveu o valor certo). A vírgula é o
//    gatilho — é o separador decimal do pt-BR — e só no BLOCO (paste/seleção
//    substituída); a DIGITAÇÃO segue registradora pura, sem exceção.
//    (a) bloco com vírgula e ≤2 casas: o decimal DECLARADO manda, com pad a 2
//        — `1.234,5` ⇒ R$ 1.234,50 · `9.542,57` ⇒ R$ 9.542,57 (exemplos do
//        owner). A casa que falta vira zero; nenhuma casa é inventada.
//    (b) bloco com vírgula e >2 casas: não é decimal declarável ⇒ DÍGITOS —
//        `1.234,567` ⇒ R$ 12.345,67 (exemplo do owner).
//    (c) bloco SEM vírgula: P4 vigente ⇒ DÍGITOS — `10000` ⇒ R$ 100,00,
//        `10.000` ⇒ R$ 100,00 (efeito já aceito por escrito).
//    (d) DIGITAÇÃO: inalterada, registradora pura.
//    (e) DUAS OU MAIS vírgulas ⇒ RECUSA (owner 2026-08-22, Q7): valor AMBÍGUO
//        nunca entra sozinho em money-path. `1,2,3` fica CRU, o parse devolve
//        NaN e a linha diz "Valor inválido em: …". Antes desta decisão a régua
//        da última vírgula o transformava em R$ 12,30 — número fabricado.
//    ⚠️ RATIFICÁVEL (escolhas que a decisão não enuncia; ver o report FS-160):
//    · a vírgula que vale é a ÚLTIMA — é o que faz `1,234.56` (en-US, UM grupo)
//      cair em (b)/(c) e sair certo, R$ 1.234,56.
//    · `12.34,56` (milhar malformado) tem UMA vírgula com 2 casas ⇒ regra (a)
//      ⇒ R$ 1.234,56. As duas leituras COINCIDEM aqui, então a escolha não é
//      observável neste caso.
//    · bloco com PONTO decimal e sem vírgula fica em (c): `9542.57` sai certo
//      por coincidência (os dígitos batem), mas `100.5` ⇒ R$ 10,05.
//    · (e) recusa também o en-US com MAIS DE UM grupo (`1,234,567.89`), que
//      antes saía certo por coincidência de dígitos — Q8 no report.
//
//    RESIDUAL DECLARADO (B1 do parecer, não corrigido de propósito): a máscara
//    é uma FUNÇÃO PURA de `(next, prev)` e o `onChange` do React não diz se o
//    texto veio de tecla ou de Ctrl+V. Quando o texto COLADO dista ≤1 caractere
//    do que já estava no campo, o `diff` o classifica como tecla e a híbrida é
//    pulada (colar `R$ 10.000,5` sobre `R$ 10.000,50` ⇒ R$ 1.000,05). Não há
//    discriminador dentro do contrato `(next, prev)`: 1 caractere inserido ou
//    removido é literalmente o mesmo evento. Resolver exigiria `onPaste` +
//    3º argumento na máscara — evento de DOM entrando numa lib pura, quebrando
//    a doutrina 3 e todo o teste por SEQUÊNCIA DE TECLAS. O caso exige que o
//    usuário já tivesse quase o mesmo valor no campo; colar em campo vazio ou
//    com "selecionar tudo" (o fluxo real) cai no bloco e acerta. Pinado em
//    teste como residual, para ser conhecido em vez de descoberto.
//    - o separador DIGITADO passa a ser inerte no campo de dinheiro: quem
//      decide onde fica a vírgula é a máscara (2 últimos dígitos = centavos).
//    - a garantia que NÃO caiu: `R$ 0,00` continua sem ser fabricado (item 5) —
//      apagar o último dígito ESVAZIA o campo, não o prende em zero.
// 2. A máscara VALIDA, nunca "conserta". Texto que não é um número pt-BR/en-US
//    bem formado NÃO é limpo até virar um positivo válido (`1e5` não vira 15,
//    `0x10` não vira 10, `100-` não vira 100, `12.34,56` não vira 1234,56):
//    tecla inválida é REJEITADA na digitação e paste inválido fica VISÍVEL e
//    cru, com `parseDecimalBR` devolvendo NaN e os gates `> 0` barrando.
// 3. DIGITAÇÃO ≠ PASTE. A máscara recebe o valor ANTERIOR e distingue uma
//    tecla (inserção/remoção de 1 caractere) de uma alteração em bloco:
//    - digitação: os pontos do texto são o AGRUPAMENTO que a própria máscara
//      inseriu (senão "1.234" + tecla "5" = "1.2345" seria recusado e o 5º
//      dígito nunca entraria), e um ponto TERMINAL é o separador decimal
//      pendente (teclas `3` `.` `5` ⇒ `3,` ⇒ `3,5`, nunca `35`);
//    - paste/valor inicial: a ESTRUTURA é validada (grupos de milhar de 3, um
//      único separador decimal), e o que não bate fica cru.
// 4. O sinal `-` NUNCA é "consertado" para positivo: `-` líder é preservado
//    (parse → NaN) e `-` no meio/fim invalida o texto.
// 5. Vazio continua VAZIO: nenhuma máscara fabrica "R$ 0,00" (doutrina do
//    `formatBRLouTraco`, item 15), e apagar o último dígito esvazia o campo.
// 6. Prefixo/sufixo são removidos por POSIÇÃO, nunca por caractere solto: só o
//    "R$" no início e o "%" no fim saem. Um símbolo no MEIO (`1$2`, `1%2`,
//    `1R2`) é entrada inválida — removê-lo faria `1$2` virar 12.
// 7. Estourar o teto de dígitos REJEITA a entrada; nunca trunca em silêncio
//    (truncar muda o valor sem o usuário ver).
//
// ── §Carga — DADO PROGRAMÁTICO ≠ ENTRADA DO USUÁRIO (FS-160) ────────────────
// A caixa registradora só pode valer para o que o USUÁRIO entrou. Um valor que
// chega da API ou de um rascunho restaurado não é digitação: se `"100.5"` (cem
// reais e cinquenta) entrasse como dígitos, viraria R$ 10,05 — /10 silencioso
// em dado JÁ GRAVADO, exatamente a classe de erro que a doutrina 1 descrevia.
//
// `maskMoneyCentsBR(next, prev)` separa os dois pela PRESENÇA de `prev`:
//   • `prev` AUSENTE (`undefined`/`null`) ⇒ não houve edição de ninguém: o
//     texto é DADO. Regime ESTRITO (delega ao mesmo motor do `maskMoneyBR`):
//     `"10000.00"` → R$ 10.000,00 · `"100.5"` → R$ 100,50 · `"R$ 9.542,57"` →
//     R$ 9.542,57 · `"10000"` → R$ 10.000 (e NÃO R$ 100,00).
//   • `prev` PRESENTE (mesmo `""`) ⇒ é o valor anterior do input CONTROLADO que
//     o React entrega no `onChange`: houve edição. Regime caixa registradora.
//
// Por que isso é honesto NO PONTO DE USO (e não uma heurística): os dois
// formulários nascem com o campo em `""` — `emptyReceivable()` (lib/operations
// .js) e `emptyItem()` (pages/Stock.jsx) —, então o `onChange` SEMPRE passa uma
// string, nunca `undefined`. A primeira tecla num campo vazio é entrada
// (`prev === ""`), não carga; e nenhum caminho de carga existe hoje passando
// `prev`. É o mesmo eixo que a doutrina 3 já usava para separar tecla de paste.
//
// ⚠️ CONTRATO para quem for carregar valor de API/rascunho nestes campos: usar
// **`loadMoneyCentsBR(valor)`**, e não `maskMoneyCentsBR` com `prev` omitido.
// "Chame sem o 2º argumento" é uma armadilha de contrato posicional (DX-1 do
// /myuxreview): quem passasse o valor do state por reflexo faria a carga entrar
// como digitação — `"10000.00"` sairia certo por coincidência (os dígitos
// batem), mas `"100.5"` viraria R$ 10,05.
// (Pinado em `numberFormat.test.js`, describe "carga programática × entrada".)
// Havia DOIS pontos de carga quando esta linha foi escrita: nenhum. Hoje são
// dois, e ambos entraram pela porta nomeada (o alias fez o trabalho para o qual
// foi escrito):
//   1. FS-161 — restauração de rascunho (NewOperation.jsx, `carregarDinheiro`).
//   2. FS-162 — o valor a antecipar derivado do "Percentual antecipado"
//      (lib/operations.js, `advanceValueFromPercent`). É a carga que MAIS se
//      pareceria com digitação se passasse o `prev`: o texto "7000,00" viraria
//      R$ 700.000,00.
// A varredura que impede a volta ao contrato posicional cobre os três arquivos
// (`numberFormat.test.js`, describe "fiação nas telas do PCP", R2-7).

import { onlyDigits } from "./representatives";

// Teto de dígitos inteiros: acima disso `Number` perde precisão (2^53) e a
// máscara passaria a MENTIR sobre o valor digitado.
const MAX_INT_DIGITS = 15;

// O Intl separa "R$" do número com NBSP (U+00A0) — usar o MESMO byte que o
// `formatBRL` para que digitação e exibição sejam idênticas.
const MONEY_PREFIX = "R$\u00a0"; // U+00A0 — o mesmo byte que o Intl insere

const groupBR = (intDigits) =>
  Number(intDigits).toLocaleString("pt-BR", { useGrouping: true, maximumFractionDigits: 0 });

/**
 * Separa sinal, prefixo/sufixo de apresentação e CORPO numérico.
 *
 * O prefixo "R$" e o sufixo "%" são removidos por POSIÇÃO. Um `replace` global
 * de `[R$%]` — como esta lib fazia — apagava o símbolo em QUALQUER lugar e
 * fazia `1$2`, `1%2` e `1R2` virarem `12`: entrada inválida promovida a número
 * válido, a mesma classe do `1e5`→15.
 *
 * Espaço em branco (inclusive o NBSP que o Intl insere entre "R$" e o número)
 * é ruído de apresentação e sai de qualquer posição. Consequência declarada:
 * `1 000` (milhar separado por espaço, padrão fr-FR/SI) é lido como 1000.
 *
 * Sinal `-` só conta como sinal ANTES dos dígitos ("-10000", "-R$ 10.000",
 * "R$ -10,00"); no meio ou no fim ("100-") é lixo e reprova em `ok`.
 *
 * @returns {{neg: boolean, body: string, ok: boolean}} `ok` = o corpo só tem
 *   dígitos, pontos e vírgulas (a ESTRUTURA ainda é validada depois).
 */
function extrairNumero(raw) {
  let s = String(raw ?? "").trim();
  let neg = false;
  if (s.startsWith("-")) { neg = true; s = s.slice(1).trimStart(); }
  if (/^R\$/i.test(s)) s = s.slice(2).trimStart();
  if (s.startsWith("-")) { neg = true; s = s.slice(1).trimStart(); }
  s = s.trimEnd();
  if (s.endsWith("%")) s = s.slice(0, -1).trimEnd();
  const body = s.replace(/\s/g, "");
  return { neg, body, ok: /^[\d.,]*$/.test(body) };
}

/**
 * Diferença entre o valor novo e o anterior como um SPLICE: posição onde a
 * edição começou, texto INSERIDO e quantos caracteres foram REMOVIDOS. É o que
 * distingue, sem heurística: tecla (1 inserido), backspace (1 removido),
 * substituição de seleção e paste em bloco.
 *
 * `unitaria` = edição de UMA tecla (inserir 1, apagar 1, ou digitar por cima de
 * 1 caractere selecionado). Só nela a intenção é inequívoca — ver
 * `edicaoAmbigua`.
 */
function diff(next, prev) {
  let pos = 0;
  while (pos < next.length && pos < prev.length && next[pos] === prev[pos]) pos += 1;
  let fim = 0;
  while (
    fim < next.length - pos &&
    fim < prev.length - pos &&
    next[next.length - 1 - fim] === prev[prev.length - 1 - fim]
  ) fim += 1;
  const ins = next.slice(pos, next.length - fim);
  const removidos = prev.length - fim - pos;
  return { pos, ins, removidos, unitaria: ins.length <= 1 && removidos <= 1 };
}

/** Valor numérico de uma leitura `{int, dec}`. */
function valorDe({ int, dec }) {
  return Number(`${int || "0"}.${dec || "0"}`);
}

/**
 * Leitura da string como número STANDALONE, para DETECTAR COLISÃO de intenção
 * (não para formatar). Além do que `lerEstrito` aceita, admite o decimal en-US
 * com qualquer número de casas (`1111.234`): não é forma que a máscara EMITE,
 * mas é exatamente o que um autofill, um undo ou um paste PRODUZEM.
 */
function lerStandalone(body) {
  const estrito = lerEstrito(body);
  if (estrito !== null) return estrito;
  const m = /^(\d+)\.(\d+)$/.exec(body);
  return m ? { int: m[1], dec: m[2] } : null;
}

/**
 * COLISÃO DE INTENÇÃO em edição NÃO-UNITÁRIA (seleção substituída, paste,
 * undo, autofill). O mesmo evento pode ser duas coisas incompatíveis:
 *
 *   anterior `1.234`, novo `1.2`
 *   (a) "apaguei a seleção `34`"        ⇒ 12       (semântica de EDIÇÃO)
 *   (b) "autofill escreveu o decimal `1.2`" ⇒ 1,2  (número STANDALONE)
 *
 * Escolher (a) calado transforma 1,2 em 12 — ×10 silencioso; escolher (b)
 * calado quebra a edição. Quando as duas leituras são válidas e os VALORES
 * divergem, a máscara **rejeita a edição** (o campo mantém o anterior): nunca
 * um número novo sem o usuário ver. Edição UNITÁRIA nunca passa por aqui — é
 * como o usuário sai do impasse, apagando caractere a caractere.
 *
 * A regra é UNIFORME: vale também para o campo monetário. Um carve-out para
 * "texto que ainda carrega o prefixo R$" parecia seguro — só a máscara produz
 * aquela decoração —, mas deixava uma janela real: o prefixo copiado da
 * PRÓPRIA máscara (com o NBSP) é byte-idêntico, então `R$ 1.2` sobre
 * `R$ 1.234` voltava a virar `R$ 12` em silêncio. As duas leituras são feitas
 * sobre o CORPO (prefixo/sufixo já removidos), então dinheiro e taxa passam
 * pelo mesmo crivo.
 *
 * Consequência declarada: uma edição em bloco sobre um valor de UM grupo
 * (`1.234`) quase sempre deixa a forma `\d+.\d+`, que é sempre um decimal
 * en-US plausível — logo quase sempre colide e o campo fica parado. É o preço
 * de nunca fabricar número: a edição unitária (tecla/backspace) segue livre.
 *
 * @returns {true|null} true = ambígua (rejeitar)
 */
function edicaoAmbigua(body, leituraSplice) {
  if (leituraSplice === null) return null;
  const standalone = lerStandalone(body);
  if (standalone === null) return null;
  return valorDe(standalone) === valorDe(leituraSplice) ? null : true;
}

/**
 * Leitura ESTRITA de um número pt-BR/en-US — usada no paste, no valor inicial
 * e no `parseDecimalBR`. Devolve `{ int, dec }` (com `dec: null` quando não há
 * separador decimal e `dec: ""` quando o separador está pendente), ou **null**
 * quando o texto é malformado.
 *
 * | entrada | leitura | resultado |
 * |---|---|---|
 * | `1,234.56` | en-US completo | `1234,56` |
 * | `1.234.567,89` | pt-BR: vírgula decide, pontos agrupam | `1234567,89` |
 * | `1.234` / `1.500` | grupos de EXATAMENTE 3 ⇒ MILHAR | `1234` / `1500` |
 * | `3.5` / `10000.00` | 1–2 casas ⇒ DECIMAL en-US | `3,5` / `10000,00` |
 * | `3.` / `3,` | separador decimal pendente | `3,` |
 * | `12.34,56`, `1..234,56`, `.1,20` | milhar MALFORMADO | **null** |
 * | `1.2345`, `1,2.3`, `1,2,3`, `1e5` | ambíguo/inválido | **null** |
 *
 * ⚠️ Consequência declarada: `2.875` é lido como MILHAR (2875), não 2,875 —
 * grupos de 3 sempre ganham. É o preço de aceitar `1.500 = 1500`, que é a
 * forma que o usuário do PCP realmente cola.
 */
function lerEstrito(corpo) {
  if (!/^[\d.,]*$/.test(corpo)) return null;
  if (corpo === "") return { int: "", dec: null };

  // Separador decimal PENDENTE: ponto terminal é vírgula terminal.
  const s = corpo.endsWith(".") ? `${corpo.slice(0, -1)},` : corpo;

  // en-US completo (vírgula agrupa, ponto decimal). Antes do ramo pt-BR:
  // sem isto "1,234.56" cairia em outro ramo e viraria 1,23 — erro de /1000.
  if (/^\d{1,3}(,\d{3})+\.\d{1,2}$/.test(s)) {
    const [int, dec] = s.replace(/,/g, "").split(".");
    return { int, dec };
  }

  const virgulas = (s.match(/,/g) || []).length;
  if (virgulas > 1) return null; // "1,2,3" não é número
  if (virgulas === 1) {
    const [head, dec] = s.split(",");
    if (!/^\d*$/.test(dec)) return null; // "1,2.3"
    // A parte inteira é dígitos puros OU milhar bem formado. É este teste que
    // recusa "12.34,56", "1..234,56" e ".1,20".
    if (head !== "" && !/^\d+$/.test(head) && !/^\d{1,3}(\.\d{3})+$/.test(head)) return null;
    return { int: head.replace(/\./g, ""), dec };
  }

  if (!s.includes(".")) return { int: s, dec: null };
  if (/^\d{1,3}(\.\d{3})+$/.test(s)) return { int: s.replace(/\./g, ""), dec: null };
  if (/^\d+\.\d{1,2}$/.test(s)) {
    const [int, dec] = s.split(".");
    return { int, dec };
  }
  return null; // "1.2345", "1..234", ".1"
}

/**
 * Leitura LENIENTE — usada SÓ no fluxo de digitação, onde os pontos do texto
 * são o agrupamento que a própria máscara inseriu (e portanto não podem ser
 * validados como se o usuário os tivesse escrito). Ponto terminal continua
 * sendo o separador decimal pendente. Devolve null quando nem assim dá número
 * (2ª vírgula ⇒ a tecla é rejeitada).
 */
function lerLeniente(corpo) {
  if (!/^[\d.,]*$/.test(corpo)) return null;
  const semAgrupamento = (corpo.endsWith(".") ? `${corpo.slice(0, -1)},` : corpo).replace(/\./g, "");
  const virgulas = (semAgrupamento.match(/,/g) || []).length;
  if (virgulas > 1) return null;
  if (virgulas === 0) return { int: semAgrupamento, dec: null };
  const [int, dec] = semAgrupamento.split(",");
  return { int, dec };
}

/** @returns {string|null} corpo formatado, ou null se estourar o teto (F7). */
function formatar({ int, dec }, scale) {
  const intDigits = onlyDigits(int);
  // Truncar em silêncio MUDA o valor sem o usuário ver — acima do teto a
  // entrada é rejeitada (a tecla não entra / o paste fica cru).
  if (intDigits.length > MAX_INT_DIGITS) return null;
  if (scale <= 0 || dec === null) return intDigits ? groupBR(intDigits) : "";
  const decDigits = onlyDigits(dec).slice(0, scale);
  // Vírgula digitada sem parte inteira vira "0," — o usuário continua digitando
  // as casas decimais a partir daí.
  return `${intDigits ? groupBR(intDigits) : "0"},${decDigits}`;
}

/** @returns {string|null} valor mascarado, ou null quando estoura o teto. */
function montar(partes, scale, moeda, neg) {
  const corpo = formatar(partes, scale);
  if (corpo === null) return null;
  if (!corpo) return "";
  return `${neg ? "-" : ""}${moeda ? MONEY_PREFIX : ""}${corpo}`;
}

/**
 * Separador decimal (`.` ou `,`) digitado em QUALQUER posição — inclusive no
 * MEIO do valor: com `35` no campo, teclar `.` entre os dígitos tem de dar
 * `3,5`. Antes só o ponto TERMINAL era reconhecido, então a tentativa de
 * corrigir `35` para `3,5` falhava sem aviso e o valor errado ficava.
 *
 * Rejeita (mantém o valor anterior) quando: o campo é inteiro, já existe um
 * separador decimal (para MOVÊ-LO é preciso apagar o antigo — foi essa regra
 * de "a última vírgula manda" que fazia `1,2` + `,` virar `12,`, ×10), ou a
 * parte decimal resultante não caberia em `scale`.
 */
function separadorNaPosicao(bruto, anterior, pos, scale, moeda) {
  if (scale <= 0) return anterior;
  if (anterior.includes(",")) return anterior;
  const { neg, ok } = extrairNumero(anterior);
  if (!ok) return bruto; // campo já estava cru: segue cru
  const int = onlyDigits(bruto.slice(0, pos));
  const dec = onlyDigits(bruto.slice(pos + 1));
  if (dec.length > scale) return anterior;
  const out = montar({ int, dec }, scale, moeda, neg);
  return out === null ? anterior : out;
}

/**
 * Motor comum das máscaras decimais.
 *
 * @param {string|number|null|undefined} next texto do input APÓS a edição
 * @param {string|number|null|undefined} prev valor ANTERIOR do campo (o estado
 *   do React). Sem ele não há como distinguir tecla de paste, e a máscara cai
 *   sempre no modo estrito.
 * @param {number} scale casas decimais máximas (0 = inteiro)
 * @param {boolean} moeda prefixa com "R$ "
 */
function mascarar(next, prev, scale, moeda) {
  if (next === null || next === undefined) return "";
  const bruto = String(next);
  if (bruto === "") return "";
  const anterior = prev === null || prev === undefined ? null : String(prev);

  // ── EDIÇÃO sobre o valor anterior ───────────────────────────────────────
  if (anterior !== null && anterior !== bruto) {
    const { pos, ins, unitaria } = diff(bruto, anterior);

    // Separador decimal, em qualquer posição.
    if (ins === "." || ins === ",") {
      return separadorNaPosicao(bruto, anterior, pos, scale, moeda);
    }

    // Só DÍGITOS entraram (ou algo foi apagado): tudo que sobrou de pontuação
    // veio do valor anterior, ou seja, é o AGRUPAMENTO que a própria máscara
    // inseriu — leitura leniente. É o que faz "1.234" + tecla "5" virar
    // "12.345" e o que sobrevive a uma substituição de seleção ("R$ 9.500,00"
    // com "500" trocado por "2" chega como "9.2,00" e volta a "R$ 92,00").
    if (/^\d*$/.test(ins)) {
      const { neg, body, ok } = extrairNumero(bruto);
      if (!ok) return bruto; // campo já cru: segue cru, sem prender o teclado
      const partes = lerLeniente(body);
      // Edição em BLOCO cuja leitura de edição colide com a leitura do texto
      // como número standalone: ambígua ⇒ rejeitada (ver `edicaoAmbigua`).
      if (!unitaria && edicaoAmbigua(body, partes)) return anterior;
      if (partes === null) {
        // Só a leitura standalone sobrou (ex.: 2ª vírgula veio do anterior):
        // usa ela em vez de descartar a edição.
        const standalone = !unitaria ? lerStandalone(body) : null;
        if (standalone === null) return anterior;
        const alt = montar(standalone, scale, moeda, neg);
        return alt === null ? anterior : alt;
      }
      const out = montar(partes, scale, moeda, neg);
      return out === null ? anterior : out; // estourou o teto: tecla rejeitada
    }

    // Uma tecla que não é dígito nem separador: REJEITADA (o campo não muda).
    // É o que impede as teclas `1` `e` `5` de virarem 15 pela digitação.
    if ([...ins].length === 1) return anterior;
    // Bloco colado com pontuação: cai no estrito abaixo (estrutura validada).
  }

  // ── PASTE / valor inicial / remascarar: ESTRITO ──────────────────────────
  const { neg, body, ok } = extrairNumero(bruto);
  // Inválido não é "consertado": fica CRU e visível, e `parseDecimalBR` devolve
  // NaN — os gates `> 0` do payload barram.
  if (!ok) return bruto;
  const partes = lerEstrito(body);
  if (partes === null) return bruto;
  const out = montar(partes, scale, moeda, neg);
  if (out !== null) return out;
  return anterior !== null ? anterior : bruto; // estourou o teto
}

/**
 * Máscara MONETÁRIA — decimal NATURAL com prefixo `R$`.
 *
 * `1` → `R$ 1` · `10000` → `R$ 10.000` · teclas `1` `0` `,` `5` → `R$ 10,5`
 * (o `onBlur` completa para `R$ 10,50` — ver `finalizeMoneyBR`; completar a
 * cada tecla impediria digitar a SEGUNDA casa decimal).
 *
 * @param {string|number|null|undefined} next texto do input já editado
 * @param {string|number|null|undefined} [prev] valor anterior do campo
 * @returns {string} valor mascarado, "" (sem dígito) ou o texto CRU (inválido)
 */
export function maskMoneyBR(next, prev) {
  return mascarar(next, prev, 2, true);
}

/**
 * Monta o valor monetário a partir da fila de CENTAVOS da caixa registradora.
 *
 * Trabalha sobre a STRING de dígitos, nunca sobre um `Number` de centavos: um
 * `cents/100` com 15 dígitos inteiros já erra na 2ª casa, e guardar centavos
 * numéricos é justamente o que abriria a dupla conversão que o §Contrato de
 * estado proíbe.
 *
 * Zeros à ESQUERDA caem — é o que faz o backspace ESVAZIAR em vez de fabricar
 * `R$ 0,00` (doutrina 5): `R$ 0,09` menos um dígito é `"00"`, que é campo
 * vazio, não zero. Consequência declarada: digitar `0` num campo de dinheiro
 * do PCP não escreve nada (a caixa registradora não tem como distinguir "quero
 * zero" de "ainda não digitei"); zero segue alcançável pela CARGA (§Carga), e
 * os gates do payload são `> 0` de qualquer forma.
 *
 * @returns {string|null} valor mascarado, "" (sem dígito significativo) ou
 *   **null** quando estoura o teto (F7: rejeita, nunca trunca).
 */
function montarCentavos(digitos, neg) {
  const cents = digitos.replace(/^0+/, "");
  if (cents === "") return "";
  // Teto em CENTAVOS = teto de inteiros + as 2 casas.
  if (cents.length > MAX_INT_DIGITS + 2) return null;
  const int = cents.length > 2 ? cents.slice(0, -2) : "0";
  const dec = cents.length >= 2 ? cents.slice(-2) : `0${cents}`;
  return `${neg ? "-" : ""}${MONEY_PREFIX}${groupBR(int)},${dec}`;
}

/**
 * Máscara MONETÁRIA "CAIXA REGISTRADORA" — o dígito entra pelos CENTAVOS.
 * Decisão do OWNER 2026-08-21 (FS-160), que reverte a doutrina 1 para os
 * campos de dinheiro do PCP; ver o bloco §Doutrina/1 e §Carga no topo.
 *
 * DIGITAÇÃO: todo dígito é dígito de centavo, os 2 últimos são as casas.
 * BLOCO (paste/seleção substituída): REGRA HÍBRIDA do owner — vírgula com ≤2
 * casas é decimal DECLARADO (pad a 2); o resto é dígito literal. Ver §Doutrina.
 *
 * | evento                         | ramo | sai                   |
 * |--------------------------------|------|-----------------------|
 * | teclas `9` `5` `4` `2` `5` `7` | (d)  | `R$ 9.542,57`         |
 * | paste `954257`                 | (c)  | `R$ 9.542,57`         |
 * | paste `9.542,57`               | (a)  | `R$ 9.542,57`         |
 * | paste `1.234,5`                | (a)  | `R$ 1.234,50`         |
 * | paste `1.234,567`              | (b)  | `R$ 12.345,67`        |
 * | paste `10000` / `10.000`       | (c)  | `R$ 100,00` ⚠️ aceito |
 * | paste `1,234.56` (en-US)       | (c)  | `R$ 1.234,56`         |
 * | backspace                      | (d)  | `R$ 954,25` (fila /10)|
 * | backspace sobre separador      | R2-1 | pula e leva o dígito  |
 * | backspace até o fim            | (d)  | `""` (nunca R$ 0,00)  |
 * | remoção que quebra o prefixo   | R2-2 | valor reconstituído   |
 * | selecionar tudo + `5`          | (c)  | `R$ 0,05`             |
 * | tecla `,` / `.`                | (d)  | REJEITADA (inerte)    |
 * | tecla `e` / paste `1e5`        | —    | anterior / cru        |
 * | 18º dígito de centavo          | —    | valor anterior (teto) |
 * | `loadMoneyCentsBR("100.5")`    | CARGA| `R$ 100,5`            |
 *
 * O CONTRATO DE ESTADO não muda: o form continua guardando a STRING mascarada
 * e `parseDecimalBR` continua sendo a ÚNICA fronteira de conversão. Nenhum
 * consumidor vê centavos.
 *
 * @param {string|number|null|undefined} next texto do input já editado
 * @param {string|number|null|undefined} [prev] valor anterior do campo. AUSENTE
 *   = carga programática (regime estrito) — ver §Carga.
 * @returns {string} valor mascarado, "" (sem dígito) ou o texto CRU (inválido)
 */
export function maskMoneyCentsBR(next, prev) {
  if (next === null || next === undefined) return "";
  const bruto = String(next);
  if (bruto === "") return "";

  // §Carga: sem valor anterior ninguém editou — é DADO, lê ESTRITO.
  if (prev === null || prev === undefined) return mascarar(bruto, undefined, 2, true);

  const anterior = String(prev);

  const { neg, body, ok } = extrairNumero(bruto);
  // Edição em BLOCO (paste, seleção substituída, autofill) × TECLA. Remascarar
  // o mesmo texto conta como bloco: não houve tecla nenhuma. É o eixo da regra
  // híbrida — a digitação é registradora PURA, o bloco é que negocia.
  let emBloco = true;

  if (anterior !== bruto) {
    const { pos, ins, removidos, unitaria } = diff(bruto, anterior);
    emBloco = !unitaria;

    // Uma tecla que NÃO é dígito é rejeitada e o campo não muda — inclusive o
    // separador, cuja posição a caixa registradora decide sozinha. Sem esta
    // guarda, um `e` datilografado cairia no ramo "inválido" e explodiria o
    // campo inteiro em texto cru só por causa de um typo.
    if ([...ins].length === 1 && !/^\d$/.test(ins)) return anterior;

    // ── REMOÇÃO que caiu sobre a DECORAÇÃO da máscara (R2 do /myuxreview) ──
    // Só vale se o campo estava VÁLIDO antes: apagar um caractere de um campo
    // que JÁ estava cru não pode "consertá-lo" em número (pin `1e` sobre
    // `1e5`) — uma remoção nunca introduz caractere inválido, ela só pode ter
    // machucado a decoração que a própria máscara escreveu.
    if (ins === "" && removidos > 0 && extrairNumero(anterior).ok) {
      // R2-1 (UX-3): o separador NÃO é apagável — apagá-lo não muda dígito
      // nenhum, então o campo devolvia o mesmo valor e lia como TRAVADO. O
      // backspace passa a PULAR o separador e levar o dígito anterior, que é
      // o que o usuário vê acontecer num campo sem máscara.
      if (removidos === 1 && /^[.,]$/.test(anterior[pos] ?? "")) {
        const antes = onlyDigits(anterior.slice(0, pos));
        const depois = onlyDigits(anterior.slice(pos + 1));
        // Sem dígito antes do separador não há o que pular (não acontece na
        // saída canônica desta máscara, onde todo separador segue um dígito).
        const alvo = antes === "" ? depois : `${antes.slice(0, -1)}${depois}`;
        const pulado = montarCentavos(alvo, neg);
        return pulado === null ? anterior : pulado;
      }
      // R2-2 (UX-4): a remoção quebrou o PREFIXO ("R 9.542,57", "$ 9.542,57").
      // O VALOR não mudou — reconstituir. Antes, o campo caía em texto cru
      // PEGAJOSO: como cru continua cru, cada dígito novo só fazia o lixo
      // crescer e não havia saída a não ser limpar o campo inteiro.
      if (!ok) {
        const reconstituido = montarCentavos(onlyDigits(bruto), neg);
        return reconstituido === null ? anterior : reconstituido;
      }
    }
  }

  // Inválido não é "consertado" (doutrina 2): fica CRU e visível, com
  // `parseDecimalBR` devolvendo NaN e os gates `> 0` barrando. Sem isto,
  // `1e5` colado viraria R$ 0,15 — a máscara promovendo lixo a número.
  if (!ok) return bruto;

  // ── Q7 (owner 2026-08-22): AMBIGUIDADE não entra sozinha em money-path ────
  // Texto com DUAS OU MAIS vírgulas não declara nada: `1,2,3` pode ser 1,23 /
  // 12,30 / 123 conforme a régua, e escolher uma calado é fabricar número.
  // Fica CRU (parse ⇒ NaN, gates `> 0` barram) e a linha mostra "Valor
  // inválido em: …" (R2-3) — o usuário corrige em vez de descobrir depois.
  // É a MESMA porta pela qual `maskMoneyBR` e `parseDecimalBR` já recusavam.
  //
  // A EXCEÇÃO não é carve-out esperto: é a régua do `lerEstrito`, a MESMA que o
  // `parseDecimalBR` (a fronteira do payload) usa. `1,234,567.89` tem duas
  // vírgulas mas é en-US canônico, e o parse já o lê sem adivinhar nada — não
  // é ambíguo. Sem esta exceção o campo mostraria texto CRU para um valor que
  // o gate `> 0` aprova, ou seja: tela quebrada e NENHUM aviso ao usuário, que
  // é pior que qualquer um dos dois extremos. A regra fica: duas vírgulas só
  // passam quando o leitor estrito sabe ler; o resto é recusa. (Q8 no report.)
  if ((body.match(/,/g) || []).length > 1 && lerEstrito(body) === null) return bruto;

  // ── (a) REGRA HÍBRIDA: vírgula DECLARADA com ≤2 casas manda ───────────────
  // Decisão do owner 2026-08-21 (UX-1), só no BLOCO: quem colou um texto que
  // termina em `,` + 1–2 dígitos DECLAROU onde ficam os centavos, e ignorar
  // isso é um ×10 na cara do usuário (`1.234,5` virava R$ 123,45). A vírgula
  // é o gatilho porque é o separador decimal do pt-BR; a casa faltante é
  // completada com zero (`,5` ⇒ `,50`), nunca inventada.
  const decDeclarado = emBloco ? /,(\d{1,2})$/.exec(body) : null;
  if (decDeclarado) {
    const intDigits = onlyDigits(body.slice(0, body.lastIndexOf(",")));
    const declarado = montarCentavos(`${intDigits}${decDeclarado[1].padEnd(2, "0")}`, neg);
    return declarado === null ? anterior : declarado;
  }

  // ── (b)/(c)/(d) DÍGITOS-LITERAL: a caixa registradora pura ────────────────
  // (b) vírgula com >2 casas — não é decimal declarável, são só dígitos
  // (`1.234,567` ⇒ R$ 12.345,67); (c) bloco SEM vírgula — P4 vigente
  // (`10000` ⇒ R$ 100,00); (d) DIGITAÇÃO — sempre, sem exceção.
  // O `-` líder é PRESERVADO (doutrina 4): o parse reprova em vez de o campo
  // devolver um positivo que o usuário não escreveu.
  const out = montarCentavos(onlyDigits(body), neg);
  return out === null ? anterior : out; // estourou o teto: entrada rejeitada
}

/**
 * Copy ÚNICA que explica o modo caixa registradora ao usuário (UX-2 do
 * /myuxreview). Vive na lib da máscara, e não em cada tela, porque é a
 * descrição do CONTRATO de `maskMoneyCentsBR`: mudar a regra sem mudar esta
 * frase (ou o contrário) é como a tela passa a mentir sobre o campo.
 * Usada em NewOperation.jsx e Stock.jsx, nos 4 campos, também via
 * `aria-describedby`.
 */
export const MONEY_CENTS_HINT = "Os 2 últimos dígitos são os centavos.";

/**
 * CARGA de um valor monetário nos campos de caixa registradora — API, rascunho
 * restaurado, qualquer dado que o usuário não digitou. Ver §Carga no topo.
 *
 * É `maskMoneyCentsBR(v)` sem o 2º argumento, com NOME em vez de convenção
 * posicional (DX-1 do /myuxreview): "chame sem o `prev`" é uma armadilha —
 * quem passasse o valor do state por reflexo faria a carga entrar como
 * digitação, e `"100.5"` viraria R$ 10,05. Aqui o `prev` é inalcançável.
 *
 * `loadMoneyCentsBR("10000.00")` → `R$ 10.000,00` · `("100.5")` → `R$ 100,5`
 * (o `onBlur` fecha o `,00`) · `("10000")` → `R$ 10.000`, NÃO R$ 100,00.
 */
export function loadMoneyCentsBR(v) {
  return maskMoneyCentsBR(v);
}

/**
 * Completa as casas decimais de um valor monetário — para usar no `onBlur`,
 * NUNCA no `onChange`: `R$ 10.000,5` → `R$ 10.000,50`, `R$ 10.000` →
 * `R$ 10.000,00`.
 *
 * Trabalha sobre a STRING (sem round-trip por float) e NÃO conserta o que é
 * inválido: vazio continua vazio, e texto que não parseia (negativo, `1e5`,
 * milhar malformado) sai como está — sem ganhar um `,00` que o faria parecer
 * um valor legítimo.
 *
 * FS-160: sobre a saída da `maskMoneyCentsBR` isto é um NO-OP idempotente (a
 * caixa registradora já emite as 2 casas sempre). Continua fiado no `onBlur`
 * porque é ele que fecha o caso da CARGA (§Carga): um valor vindo da API como
 * `R$ 10.000` ganha o `,00` ao sair do campo. Lê pelo `maskMoneyBR` — o regime
 * ESTRITO — de propósito: um finalize que relesse em centavos multiplicaria
 * por 100 a cada blur.
 */
export function finalizeMoneyBR(v) {
  const s = maskMoneyBR(v);
  if (!s) return "";
  const n = parseDecimalBR(s);
  if (n === null || Number.isNaN(n)) return s;
  const i = s.lastIndexOf(",");
  if (i < 0) return `${s},00`;
  return `${s.slice(0, i)},${`${s.slice(i + 1)}00`.slice(0, 2)}`;
}

/**
 * Máscara DECIMAL pt-BR: a vírgula é o separador decimal ("2,5" fica "2,5", e
 * não "0,25"), o ponto é desambiguado (colar "3.5" dá "3,5", NÃO "35"; teclar
 * `3` `.` dá "3,") e as casas são truncadas em `scale`.
 *
 * `scale: 0` = inteiro (a vírgula nunca sobrevive).
 *
 * @param {string|number|null|undefined} next
 * @param {string|number|null|undefined} [prev] valor anterior do campo
 * @param {{scale?: number}} [opts]
 */
export function maskDecimalBR(next, prev, { scale = 2 } = {}) {
  return mascarar(next, prev, scale, false);
}

/**
 * Máscara de PERCENTUAL — decimal pt-BR sem o sufixo "%" (o rótulo do campo já
 * diz "(%)"; sufixo dentro do input atrapalha edição e leitor de tela).
 */
export function maskPctBR(next, prev, opts) {
  return maskDecimalBR(next, prev, opts);
}

/**
 * Máscara de INTEIRO: só dígitos, com teto opcional. Usada em campos que NÃO
 * são dinheiro (dias de floating, código de banco).
 *
 * Mesma doutrina das decimais: tecla não-dígito é rejeitada, paste inválido
 * (`1e5`, `00-1`) fica CRU e visível, e o `-` líder é preservado para que o
 * consumidor reprove o negativo em vez de recebê-lo positivo.
 *
 * @param {string|number|null|undefined} next
 * @param {string|number|null|undefined} [prev] valor anterior do campo
 * @param {number} [max] teto de dígitos
 */
export function maskDigits(next, prev, max) {
  if (next === null || next === undefined) return "";
  const bruto = String(next);
  if (bruto === "") return "";
  const anterior = prev === null || prev === undefined ? null : String(prev);

  if (anterior !== null && anterior !== bruto) {
    const { ins } = diff(bruto, anterior);
    // Tecla que não é dígito: REJEITADA (o campo não muda).
    if (!/^\d*$/.test(ins) && [...ins].length === 1) return anterior;
  }

  const { neg, body, ok } = extrairNumero(bruto);
  if (!ok || !/^\d*$/.test(body)) return bruto; // inválido: cru e visível
  // Teto REJEITA, não trunca (F7): truncar "1234567" para "123" mudaria o
  // valor em silêncio.
  if (max && body.length > max) return anterior !== null ? anterior : bruto;
  if (!body) return "";
  return neg ? `-${body}` : body;
}

/**
 * Identificador bancário (agência/conta) com ESTRUTURA explícita:
 * `dígitos` + (opcional) `-` + `DV`, onde o DV é UM caractere — dígito ou `X`
 * (Banco do Brasil) — e só existe na ÚLTIMA posição.
 *
 * O `X` fora do DV (`X1234`, `12X34`) não é DV: cai como qualquer outra letra
 * que o campo já descartava. Hífen extra não sobrevive, e o teto vale só para
 * a parte NUMÉRICA — cortar a string inteira comia o DV de uma agência/conta
 * no comprimento máximo ("12345-X" virava "12345-").
 *
 * Estourar o teto REJEITA a edição (volta ao valor anterior) em vez de truncar
 * o identificador em silêncio. Sem valor anterior (carga inicial vinda da API)
 * o valor passa inteiro: truncar dado JÁ GRAVADO seria pior que exibi-lo.
 *
 * `1234-` (hífen sem DV) é estado intermediário legítimo enquanto se digita;
 * `finalizeBankIdentBR` o resolve no blur.
 */
function maskBankIdent(next, prev, maxDigits) {
  if (next === null || next === undefined) return "";
  const anterior = prev === null || prev === undefined ? null : String(prev);
  const s = String(next).toUpperCase().replace(/[^0-9X-]/g, "");
  const i = s.indexOf("-");
  const numero = (i < 0 ? s : s.slice(0, i)).replace(/X/g, "");
  if (maxDigits && numero.length > maxDigits && anterior !== null) return anterior;
  if (i < 0) return numero;
  const dv = s.slice(i + 1).replace(/-/g, "").slice(0, 1);
  return `${numero}-${dv}`;
}

/**
 * Resolve o estado intermediário do identificador bancário no `onBlur`: um
 * hífen sem DV (`1234-`) não é um identificador — sai. Não inventa DV.
 */
export function finalizeBankIdentBR(v) {
  const s = String(v ?? "");
  return s.endsWith("-") ? s.slice(0, -1) : s;
}

/** Máscara de CONTA bancária. Ver `maskBankIdent`. */
export function maskContaBR(next, prev) {
  return maskBankIdent(next, prev, 20);
}

/**
 * Máscara de AGÊNCIA — MESMO desenho da conta, e pelo mesmo motivo: agência
 * também tem DV ("1234-X" no BB). Uma máscara de "5 dígitos secos" apagava o
 * hífen e o `X` e mudava o identificador bancário do cedente em SILÊNCIO
 * ("1234-X" → "1234"), num campo cujo contrato no backend é texto livre.
 */
export function maskAgenciaBR(next, prev) {
  return maskBankIdent(next, prev, 5);
}

/**
 * Desfaz a máscara: string pt-BR (mascarada ou não) → `number`.
 *
 * - `""`/`null`/`undefined` → **null** (campo vazio é AUSÊNCIA de valor, não 0)
 * - inválido — texto ("abc", "1e5", "0x10"), sinal `-`, milhar malformado
 *   ("12.34,56"), ponto ambíguo ("1.2345") → **NaN** (sentinela; `NaN > 0` é
 *   `false`, então todo gate `> 0` do repo continua rejeitando exatamente como
 *   com `parseFloat`)
 * - `0`/`"0,00"` → **0** preservado (zero é valor, não vazio)
 *
 * O `-` reprova em vez de virar número negativo porque o campo é de dinheiro/
 * taxa: negativo ali é sempre entrada inválida, e a sentinela deixa isso
 * explícito na fronteira do payload. (Um `number` negativo passado direto
 * — fixture, resposta de API — segue intacto: a regra é sobre TEXTO digitado.)
 *
 * A leitura é a de `lerEstrito` — a MESMA que a máscara usa no paste, para que
 * nada que o parse recuse consiga entrar formatado pela tela.
 *
 * @returns {number|null} number, null (vazio) ou NaN (inválido)
 */
export function parseDecimalBR(v) {
  if (v === null || v === undefined) return null;
  if (typeof v === "number") return v;
  const trimmed = String(v).trim();
  if (trimmed === "") return null;
  const { neg, body, ok } = extrairNumero(trimmed);
  if (neg) return NaN; // sinal: inválido, não "consertado" nem negativo válido
  if (!ok || body === "") return NaN;

  const partes = lerEstrito(body);
  if (partes === null) return NaN;
  const int = partes.int;
  const dec = partes.dec ?? "";
  if (int === "" && dec === "") return NaN; // só "," ou só "."

  const n = Number(`${int || "0"}.${dec || "0"}`);
  return Number.isFinite(n) ? n : NaN;
}
